import React from "react";
import tw, { css } from "twin.macro";

import Process from "../../static/images/triangular-process.png";
import DarkContainer from "../components/DarkContainer";
import Hero from "../components/Hero";
import { Layout } from "../components/Layout/Layout";
import AgencyServices from "./index/AgencyServices";
import AgencyStage1 from "./index/AgencyStage1";
import AgencyStage2 from "./index/AgencyStage2";
import AgencyStage3 from "./index/AgencyStage3";
import Banner from "./index/Banner";
import HowItWorksIndex from "./index/HowItWorksIndex";
import LogosBlock from "./index/LogosBlock";
import MaterialProcessing from "./index/MaterialProcessing";
import ProfilesBlock from "./index/ProfilesBlock";
import SearchCards from "./index/SearchCards";
import TwoOptions from "./index/TwoOptions";
import VideoBlock from "./index/VideoBlock";
import YouReadAllBlock from "./index/YouReadAllBlock";
import FreeReport from "./opt_in/FreeReport";

const styles = css`
  article {
    ${tw`sm:max-w-3xl mx-1 sm:mx-auto text-center`}
  }
  article#banner {
    ${tw`max-w-[62rem]`}
  }
  article#logos {
    ${tw`max-w-4xl`}
  }
  h2 {
    ${tw`leading-none text-3xl sm:text-5xl font-black mb-10`}
  }
  div section {
    ${tw`py-8 sm:(py-12)`}
  }
  div#bookMeeting {
    ${tw`max-w-lg mx-auto`}
  }
  h3#videoIntro {
    ${tw`leading-none text-2xl sm:text-4xl font-bold mb-10`}
  }
`;

const Index: React.FC = () => {
  return (
    <Layout
      css={styles}
      ogTitle={"Triangular-pod - The Process On Demand Platform"}
      author={"Triangular-pod"}
      ogImage={Process}
      ogDescription={
        "We provide access to available production capacities and experts to people that need to use these resources to create new products. We aim for excellent communication with our partners to understand their requirements and find the perfect match between materials, processing systems, and knowledge."
      }
      ogURL={"www.triangular-pod.com/"}
    >
      <Hero tw="pb-6 sm:(pb-8)">
        <Banner />
      </Hero>
      <DarkContainer>
        <ProfilesBlock />
      </DarkContainer>
      <hr />
      <VideoBlock />
      <DarkContainer>
        <TwoOptions />
      </DarkContainer>
      <HowItWorksIndex />
      <DarkContainer>
        <AgencyServices />
      </DarkContainer>
      <AgencyStage1 />
      <DarkContainer>
        <AgencyStage2 />
      </DarkContainer>
      <AgencyStage3 />
      <DarkContainer>
        <SearchCards />
      </DarkContainer>
      <MaterialProcessing />
      <DarkContainer>
        <LogosBlock />
      </DarkContainer>
      <FreeReport />
      <DarkContainer>
        <YouReadAllBlock tw="sm:max-w-3xl mx-1 sm:mx-auto text-center" />
      </DarkContainer>
      <hr />
    </Layout>
  );
};

export default Index;
